// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e560239","455":"7bfcef99","977":"a78c35e0"}[chunkId] + ".chunk.js";
};